var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "permission-info" }, [
    _c("span", { staticClass: "material-icons mr-2" }, [
      _vm._v(_vm._s(_vm.icon)),
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.text))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }